export default {
  locale: "en",
  name: "Configuration manager",
  translation: { displayName: "Translations" },
  fields: {
    list: [],
    form: [
      {
        fieldName: "useCustomEmailTemplate",
        displayName: "Use custom templates",
        description: "Activate this to allow the user to create their own templates",
        helpText: "If no template is created and active the default template will be used",
      },
      {
        fieldName: "pedircodigoseguridad",
        displayName: "Activate CCV field for PCIProxy",
        description: "Activates the CCV Field for the PCIProxy payment type",
        helpText:
          "Currently only works for PCI Proxy, could be expanded to other payment types in the future",
      },
    ],
  },
};
